import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

export default function DeleteDialog({
  codeName,
  open,
  onClose,
  onDelete,
}: {
  codeName: string;
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle color="error">クーポンコード削除の確認</DialogTitle>
      <DialogContent>
        <DialogContentText>
          クーポンコード「<Typography component="span">{codeName}</Typography>
          」を削除してもよろしいですか？
          削除するとユーザーはこのクーポンコードを使用できなくなります。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default" autoFocus>
          キャンセル
        </Button>
        <Button onClick={onDelete} color="default">
          削除する
        </Button>
      </DialogActions>
    </Dialog>
  );
}
